import { lazy, Suspense, useEffect, useMemo, useState } from "react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { Layout, Spin } from "antd"

import type { EstruturaRotasCompleta, Rota } from "./types"
import { carregarPagina } from "./paginas/paginasLoader"
import { menuService } from "./services/menuService"

import MenuComponent from "./components/menuComponent"
import RodapeComponent from "./components/RodapeComponent"
import "antd/dist/reset.css"; // novo reset do Ant Design v5
import "./App.css"

const { Content } = Layout;

// Componente de fallback para o Suspense (mostrado enquanto as páginas carregam)
const PaginaCarregando = () => (
  <div className="suspense-fallback">
    <Spin size="large" />
  </div>
);

function App() {
  const [estruturaCompleta, setEstruturaCompleta] = useState<EstruturaRotasCompleta | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    menuService
      .getRotasDinamicas()
      .then((estrutura) => {
        setEstruturaCompleta(estrutura)
      })
      .catch((err) => {
        console.error("Erro ao carregar estrutura de rotas:", err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  // Usamos useMemo para criar os componentes lazy apenas uma vez
  const rotasDinamicas = useMemo(() => {
    if (!estruturaCompleta) return [];

    // CORREÇÃO: Usamos o tipo que realmente vem do backend.
    // O TypeScript já sabe o tipo correto, então podemos até omiti-lo,
    // ou usar o tipo que o erro indicou. O importante é usar as propriedades certas.
    return estruturaCompleta.routes.map((rota) => {

      // O nome do componente continua vindo de 'pagina_tsx'
      const ComponenteLazy = lazy(() => carregarPagina(rota.pagina_tsx));

      return (
        <Route
          // CORREÇÃO: Usamos 'rota.path' para a chave e o caminho
          key={rota.path}
          path={rota.path}
          element={<ComponenteLazy />}
        />
      );
    });
  }, [estruturaCompleta]);

  if (loading) {
    return (
      <div className="app-loading">
        <p>Carregando aplicação...</p>
      </div>
    )
  }

  return (
    <BrowserRouter>
      <Layout className="layout">
        {/* O MenuComponent já renderiza um <Header>, então o colocamos aqui */}
        <MenuComponent estruturaCompleta={estruturaCompleta} />

        {/* O Content agora tem padding para lidar com o header/footer fixos */}
        <Content className="content">
          <Suspense fallback={<PaginaCarregando />}>
            <Routes>
              {rotasDinamicas}
              {/* Rota padrão para redirecionar para /home se nenhuma outra corresponder */}
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </Suspense>
        </Content>

        {/* O RodapeComponent já renderiza um <Footer> */}
        <RodapeComponent />
      </Layout>
    </BrowserRouter>
  )
}

export default App